module.exports = __webpack_public_path__ + "img/progress-task-top.543246d0.png";